import { lessonsData } from '../data/lessonsData';

interface LessonsListProps {
  selectedLesson: number | null;
  onSelectLesson: (lessonNumber: number) => void;
}

export default function LessonsList({ selectedLesson, onSelectLesson }: LessonsListProps) {
  return (
    <div className="bg-white rounded-2xl p-6 border border-gray-200">
      <h3 className="text-xl font-bold text-black mb-4">Lecciones del Módulo</h3>
      <div className="space-y-2">
        {lessonsData.map((lesson, index) => (
          <button
            key={index}
            onClick={() => onSelectLesson(index + 1)}
            className={`w-full text-left px-4 py-3 rounded-xl transition-all whitespace-nowrap cursor-pointer ${
              selectedLesson === index + 1
                ? 'bg-[#39FF14] text-black font-medium'
                : 'bg-[#F5F2EB] text-gray-700 hover:bg-[#39FF14]/20'
            }`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                selectedLesson === index + 1 ? 'bg-black text-[#39FF14]' : 'bg-white text-gray-700'
              }`}>
                <span className="text-sm font-bold">{index + 1}</span>
              </div>
              <span className="text-sm leading-tight">{lesson.title}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}